export default __webpack_public_path__ + "static/media/blog-3.f0a37cf3.jpg";